var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTechStackGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9606_28553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 11.333L8.00065 14.6663L14.6673 11.333M1.33398 7.99967L8.00065 11.333L14.6673 7.99967M8.00065 1.33301L1.33398 4.66634L8.00065 7.99967L14.6673 4.66634L8.00065 1.33301Z",
    stroke: "#98A2B3",
    strokeWidth: 1.24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9606_28553"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechStackGrey);
export default "data:image/svg+xml,%3csvg width='16' height='16' viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg clip-path='url(%23clip0_9606_28553)'%3e %3cpath d='M1.33398 11.333L8.00065 14.6663L14.6673 11.333M1.33398 7.99967L8.00065 11.333L14.6673 7.99967M8.00065 1.33301L1.33398 4.66634L8.00065 7.99967L14.6673 4.66634L8.00065 1.33301Z' stroke='%2398A2B3' stroke-width='1.24' stroke-linecap='round' stroke-linejoin='round'/%3e %3c/g%3e %3cdefs%3e %3cclipPath id='clip0_9606_28553'%3e %3crect width='16' height='16' fill='white'/%3e %3c/clipPath%3e %3c/defs%3e %3c/svg%3e";
export { ForwardRef as ReactComponent };